import queryString from 'query-string'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import useTracking from '@src/components/shared/Tracking/useTracking'
import { helpWidget } from '@src/lib/HelpWidget'
import postMessage from '@src/lib/postMessage'

import BeaconHider from '../../../lib/BeaconHider'
import {
  userSelector,
  currentRetailerAccountSelector,
} from '../../../stores/app/selectors'
import IGDesktopSetup from '../../shared/IGDesktopSetup'

//Temporary page meant to be used by R1 in an iframe only.
//IGDesktopSetupPage
export function IGDesktopSetupPage() {
  /** @type {React.RefObject<HTMLDivElement>} */
  const { track } = useTracking()
  const containerRef = useRef(null)

  const currentUser = useSelector(userSelector) //TODO: Eventually replace this with nice hook
  const currentRetailerAccount = useSelector(currentRetailerAccountSelector) //TODO: Eventually replace this with nice hook

  useEffect(() => {
    //Hacky, supress the HelpScout beacon on this page.
    try {
      helpWidget.hideAll()
    } catch (error) {
      console.error(error)
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }

      postMessage(window.parent, {
        type: 'IgDesktopSetup/size',
        payload: {
          height: entry.contentRect.height,
        },
      })
    })
    observer.observe(containerRef.current)

    postMessage(window.parent, {
      type: 'IgDesktopSetup/load',
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    track({
      event: 'View',
      data: {
        type: 'Saw IG Desktop Setup Dialog',
        feature: 'IG Auto Share',
        // This seems hacky... But this dialog only appears in two places and this seems like the best way to differentiate.
        source: window.parent.location.href.includes('social_accounts')
          ? 'Business Info'
          : 'IG Share Flow',
      },
    })
  }, [track])

  if (currentUser && currentRetailerAccount) {
    const { retailerId } = queryString.parse(window.location.search)

    return (
      <div ref={containerRef}>
        <IGDesktopSetup retailerId={retailerId} />
        <BeaconHider />
      </div>
    )
  } else {
    return null
  }
}
